export default "__VITE_ASSET__50949773__"